import { render } from "./Tours.vue?vue&type=template&id=2d3c33c8"
import script from "./Tours.vue?vue&type=script&lang=js"
export * from "./Tours.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/views/Tours.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d3c33c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d3c33c8', __exports__)) {
    api.reload('2d3c33c8', __exports__)
  }
  
  module.hot.accept("./Tours.vue?vue&type=template&id=2d3c33c8", () => {
    api.rerender('2d3c33c8', render)
  })

}


export default __exports__